export default "* Dyrespor\n* Undersøge\n* Synssans \n";